import ReminderTranslationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/ReminderService/ReminderTranslationResponse";

export default class ReminderTranslateModel {
    langCode: string = '';
    title: string = '';
    text: string = '';
    constructor(obj?: Partial<ReminderTranslateModel>) {
        if (obj) {
            this.langCode = obj.langCode;
            this.title = obj.title;
            this.text = obj.text;
        }
    }
    toServerModel(): ReminderTranslationResponse {
        return new ReminderTranslationResponse({
            LangCode: this.langCode,
            Text: this.text,
            Title: this.title
        });
    }
    fromServerModel(res: ReminderTranslationResponse) {
        this.langCode = res.LangCode;
        this.text = res.Text;
        this.title = res.Title;
    }
}